module.exports = __webpack_public_path__ + "static/icons/icon-more-menu-2bd1ef86355f3467a8a68194dd9ead05.svg";